<h3 class="header-upload" mat-dialog-title>Role Permissions</h3>
<mat-dialog-content>
    <div style="padding: 15px; ">
        <div class="flex flex-row mb-3">
            <div [style.width.px]="data.type === typesMerchantEmployee.StoreEmployees ? 190 : 110"></div>
            <div *ngFor="let role of data.type === typesMerchantEmployee.StoreEmployees ? storeRoles : adminRoles" class="tab-text-color tab-width-column">{{ role.name }}</div>
        </div>
        <hr style="margin: 0px 1px -10px 1px;" class="hr-filter" />
        <div *ngFor="let group of groupedRoleRights; let last = last">
            <div>
                <div class="tab-groupname tab-text-color" [style.width.px]="data.type === typesMerchantEmployee.StoreEmployees ? 190 : 110">{{ group.GroupName }}</div>
                <div *ngFor="let action of group.Actions">
                    <div class="flex flex-row">
                        <div class="tab-displayname tab-text-color" [style.width.px]="data.type === typesMerchantEmployee.StoreEmployees ? 190 : 110">{{ action.DisplayName }}</div>
                        <div class="flex flex-row" *ngFor="let role of data.type === typesMerchantEmployee.StoreEmployees ? storeRoles : adminRoles">
                            <div style="position: relative;" class="tab-width-column" *ngIf="hasPermission(action, role.id)"><mat-icon class="check-icon">check_circle</mat-icon></div>
                            <div style="position: relative;" class="tab-width-column" *ngIf="!hasPermission(action, role.id)"><mat-icon class="cancel-icon">cancel</mat-icon></div>
                        </div>
                    </div>
                </div>
                <hr *ngIf="!last" style="margin: 0px 1px -10px 1px;" class="hr-filter" />
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="close-btn" mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>